import React from "react";
import { styled, DialogActions } from "@mui/material";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const StepperFooter = ({
  secondaryButtonText = "Back",
  isSecondaryButtonDisabled,
  handleBack,
  isPrimaryButtonLoading,
  primaryButtonText = "Next",
  isPrimaryButtonDisabled,
  handleClickNext
}) => <StyledDialogActions>
  {!!secondaryButtonText && <HyroButton
    variant={BUTTON_VARIANTS.TEXT}
    color={BUTTON_COLORS.SECONDARY}
    disabled={isSecondaryButtonDisabled}
    onClick={handleBack}
  >
    {secondaryButtonText}
  </HyroButton>}

  {!!primaryButtonText && <HyroButton
    loading={isPrimaryButtonLoading}
    onClick={handleClickNext}
    disabled={isPrimaryButtonDisabled}
    data-testid="hyro-dialog-next-button"
    variant={BUTTON_VARIANTS.CONTAINED}
    color={BUTTON_COLORS.PRIMARY}
  >
    {primaryButtonText}
  </HyroButton>}
</StyledDialogActions>;

export default StepperFooter;

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  display: "flex",
  padding: "16px 24px",
  borderTop: `1px solid ${theme.palette.grey[300]}`
}));
